import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import * as CryptoJS from 'crypto-js';
import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { GrupoClienteModel } from 'app/model/cliente/grupocliente.model';
import { GrupoclienteService } from 'app/service/cliente/grupocliente.service';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-grupocliente',
  templateUrl: './grupocliente.component.html',
  styleUrls: ['./grupocliente.component.scss'],
})
export class GrupoclienteComponent implements OnInit {
  public submit = false;
  public loading = true;

  @ViewChild('cardEdit') targetEl: ElementRef;

  grupoCliente = {} as GrupoClienteModel;
  grupoClientes: GrupoClienteModel[];

  public page: ResponsePageable;

  public pageAtual = 0;

  public arrayString: string;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  user: any;
  createGrupoCliente = false;
  editorGrupoCliente = false;
  listGrupoCliente = false;
  deletarGrupoCliente = false;
  superUser = false;
  @ViewChild('grupoDescricao') grupoDescricaoInput: ElementRef;

  constructor(
    private grupoclienteService: GrupoclienteService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService
  ) {}

  ngOnInit() {
    // this.listarPageGrupoCliente(0, 10);
    this.listarGruposPorClienteUser(0, 10);
    this.getAuthority();
  }

  listarPageGrupoCliente(page, size) {
    this.grupoclienteService
      .getPageGrupoCliente(page, size)
      .subscribe((res) => {
        this.page = res;
        this.grupoClientes = this.page.content;
      });
  }

  listarGruposPorClienteUser(page: number, size: number) {
    this.grupoclienteService.getGruposClienteUsuario(page, size).subscribe(
      (data) => {
        this.page = data;
        this.grupoClientes = this.page.content;
        this.loading = false;
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  listarGrupoClientes() {
    this.grupoclienteService.getGrupoCliente().subscribe((data) => {
      this.grupoClientes = data.content;
    });
  }

  changePage(event) {
    this.listarGruposPorClienteUser(event.page, event.size);
    this.pageAtual = event.page;
  }

  onSubmit() {
    this.submit = true;
  }

  postSubmit() {
    this.submit = false;
    this.grupoCliente.id = undefined;
    this.grupoDescricaoInput.nativeElement.value = '';
    this.grupoCliente.descricao = null;
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }

  saveOrEdit() {
    if (this.grupoCliente.id !== undefined) {
      this.editGrupoCliente();
    } else {
      this.cadastrarGrupoCliente();
    }
  }

  editGrupoCliente() {
    this.grupoclienteService.putGrupoCliente(this.grupoCliente).subscribe(
      (data) => {
        this.grupoCliente = new GrupoClienteModel();
        this.openSnackBarSuccess('Grupo de cliente atualizado com sucesso !');
        this.postSubmit();
        this.listarGruposPorClienteUser(this.pageAtual, 10);
      },
      (err) => {
        console.error(err);
        this.openSnackBarError('Erro ao editar o Grupo de cliente !');
      }
    );
  }

  cadastrarGrupoCliente() {
    this.grupoclienteService.postGrupoCliente(this.grupoCliente).subscribe(
      (grupoCliente) => {
        this.grupoCliente = new GrupoClienteModel();
        this.listarGruposPorClienteUser(this.pageAtual, 10);
        this.openSnackBarSuccess('Grupo de cliente salvo com sucesso !');
        this.postSubmit();
      },
      (err) => {
        console.log(err);
        this.openSnackBarError('Erro ao adicionar o Grupo de cliente !');
      }
    );
  }

  editarTipoCliente(grupoCliente: GrupoClienteModel) {
    this.grupoCliente = { ...grupoCliente };
  }

  confirmeExclusao(id: number) {
    var confirme = confirm('Deseja excluir este grupo de cliente ?');
    if (confirme === true) {
      this.deleteGrupoCliente(id);
    } else {
      console.log('Cancelou exclusão!');
    }
  }

  deleteGrupoCliente(id: number) {
    this.grupoclienteService.deleteGrupoCliente(id).subscribe(
      (grupoCliente) => {
        this.grupoCliente = new GrupoClienteModel();
        this.listarGruposPorClienteUser(0, 10);
        this.openSnackBarSuccess('Grupo de cliente excluído com sucesso!');
      },
      (err) => {
        if (err.status == 500) {
          this.openSnackBarError('Erro ao excluir! Este grupo de cliente está sendo usado por um cliente.');
        }
        console.log('error', err.status);
      }
    );
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.createGrupoCliente = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorGrupoCliente = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listGrupoCliente = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletarGrupoCliente = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/cliente-components/grupocliente/grupocliente.component.ts